import axios from 'axios';
import { JobBoardSettingsDto } from '../types/jobBoard';
import { JOBBOARD_API_BASE_URL } from './apiConfig';

const api = axios.create();
const API_BASE = `${JOBBOARD_API_BASE_URL}/api/jobboardsettings/me`;

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const jobBoardSettingsApi = {
  getSettings: () => api.get<JobBoardSettingsDto>(API_BASE),
  saveSettings: (data: JobBoardSettingsDto) => api.post<JobBoardSettingsDto>(API_BASE, data),
};

export const JobBoardSettingsApi = jobBoardSettingsApi;